export { default } from "./PortalLayout";
export { default as PortalLayout } from "./PortalLayout";
export type { PortalLayoutProps } from "./PortalLayout";

export { default as Sidebar } from "./Sidebar";
export type { SidebarCompany, SidebarUser } from "./Sidebar";

export { default as Topbar } from "./Topbar";
export type { BreadcrumbItem } from "./Topbar";

export { usePortalChrome } from "./PortalChrome";
export type { PortalChrome } from "./PortalChrome";

export { default as Icon } from "./icons";
export type { IconName } from "./icons";

export { NAV_SECTIONS } from "./nav-config";
export type { NavItem, NavSection } from "./nav-config";

// UI primitives for migrated page content
export {
  Button,
  Badge,
  Card,
  PageHeader,
  FormField,
  InfoTooltip,
  Switch,
  Input,
  Select,
  DataTable,
  Modal,
  Tabs,
} from "./ui";
export type { ButtonVariant, ButtonSize, BadgeTone, Column, DataTablePagination, ModalSize, TabItem } from "./ui";
